export default {
	title: 'roval',

	colors: {
		primary: '#C10230',
		secondary: '#d40638',
	},
};
